<script context="module">
  import { createRequest } from '../utils/request';

  export async function load({ session }) {
    const { API_BASE_URL, API_KEY, LANGUAGE } = session;

    return {
      props: {
        API_BASE_URL,
        API_KEY,
        LANGUAGE,
      },
    };
  }
</script>

<script>
  import { onMount } from 'svelte';

  import Alert from '../components/Alert.svelte';
  import Field from '../components/Field.svelte';
  import Button from '../components/Button.svelte';
  import { _ } from 'svelte-i18n';

  import { FormStatuses } from '../constants';

  export let API_BASE_URL, API_KEY, LANGUAGE;
  const request = createRequest({
    apiBaseUrl: API_BASE_URL,
    apiKey: API_KEY,
    language: LANGUAGE,
  });

  const initialValues = { Id: '', CancellationCode: '', UnBookedComments: '' };
  let values = { ...initialValues };
  let touched = {};
  let message,
    status,
    loading = false;

  $: errors = validate(values);

  function validate(values = {}) {
    const errors = {};

    return errors;
  }

  async function handleSubmit(e) {
    loading = true;
    request({
      url: `/bookings/deletebycode/${values.Id}?`,
      params: values,
      method: 'DELETE',
    })
      .then((data) => {
        message = $_('common.bookingCancelled');
        status = FormStatuses.SUCCESS;
        resetForm();
      })
      .catch((error) => {
        const { data } = error.response;

        if (data && data.ResponseStatus) {
          if (data.ResponseStatus.Errors) {
            const submissionErrors = {};

            data.ResponseStatus.Errors.forEach((error) => {
              errors = submissionErrors[error.FieldName] = error.Message;
            });

            errors = submissionErrors;
          }

          if (data.ResponseStatus.Message) {
            message = data.ResponseStatus.Message;
            status = FormStatuses.DANGER;
          }
        }
      })
      .finally(() => {
        loading = false;
      });
  }

  function resetForm() {
    values = { ...initialValues };
  }

  function handleBlur(e) {
    touched = { ...touched, [e.target.name]: true };
  }

  onMount(() => {
    window.__READY_FOR_E2E__ = true;
  });
</script>

<svelte:head>
  <title>{$_('cancelBooking.title')} | {$_('common.title')}</title>
</svelte:head>

<div class="container">
  <h1>{$_('cancelBooking.title')}</h1>
  <div class="login-link">
    {$_('cancelBooking.linkToLogin.or')}
    <a href="https://profile.bookmore.com" rel="noopener">
      {$_('cancelBooking.linkToLogin.login')}
    </a>
    {$_('cancelBooking.linkToLogin.toSeeYourBookings')}
  </div>
  <form class="form" on:submit|preventDefault={handleSubmit}>
    <Field
      bind:value={values.Id}
      error={touched.Id && errors.Id}
      id="Id"
      label="Bokningsnummer"
      required
      onBlur={handleBlur}
      type="number"
    />
    <Field
      bind:value={values.CancellationCode}
      error={touched.CancellationCode && errors.CancellationCode}
      id="CancellationCode"
      label="Avbokningskod"
      required
      onBlur={handleBlur}
    />
    <Field
      bind:value={values.UnBookedComments}
      error={touched.UnBookedComments && errors.OrganisationNumber}
      id="UnBookedComments"
      label="Avbokningsmeddelande"
      type="textarea"
      onBlur={handleBlur}
    />
    {#if message}
      <div class="field grid">
        <div class="col-3" />
        <div class="col-6">
          <div class="alert-container">
            <Alert {message} type={status} />
          </div>
        </div>
      </div>
    {/if}
    <div class="field grid">
      <div class="col-9 form__buttons">
        <Button primary type="submit" {loading}>
          {$_('cancelBooking.unbook')}
        </Button>
      </div>
    </div>
  </form>
</div>

<style>
  .container {
    padding: 40px 20px;
  }
  .form__buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .form__buttons :global(.button) {
    display: block;
    margin-left: 20px;
  }
  .login-link {
    margin-bottom: 32px;
    text-align: center;
  }
  h1 {
    margin-bottom: 32px;
  }
  a {
    color: #6A35A3;
    font-weight: 600;
  }
  .alert-container {
    margin-bottom: 20px;
  }
</style>
